import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

import { useRouter } from 'vue-router'

interface Props {
  dataMenu: any[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuMobile',
  props: {
    dataMenu: { default: () => [] }
  },
  setup(__props: any) {

const props = __props

const router = useRouter()
const active = router.currentRoute.value.path

const go = (path: string) => {
  router.push(path)
}

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_menu, {
      mode: "inline",
      selectedKeys: [_unref(active)],
      class: "mobile-menu"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataMenu, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            (item.children && item.children.length)
              ? (_openBlock(), _createBlock(_component_a_sub_menu, {
                  key: item.id
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("span", null, [
                      (item.icon)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            class: _normalizeClass(item.icon)
                          }, null, 2))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(item.linkLabel), 1)
                    ])
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: child.id
                      }, [
                        (child.children && child.children.length)
                          ? (_openBlock(), _createBlock(_component_a_sub_menu, {
                              key: child.id
                            }, {
                              title: _withCtx(() => [
                                _createTextVNode(_toDisplayString(child.linkLabel), 1)
                              ]),
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.children, (sub) => {
                                  return (_openBlock(), _createBlock(_component_a_menu_item, {
                                    key: sub.linkTo,
                                    onClick: ($event: any) => (go(sub.linkTo))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(sub.linkLabel), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024))
                          : (_openBlock(), _createBlock(_component_a_menu_item, {
                              key: child.linkTo,
                              onClick: ($event: any) => (go(child.linkTo))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(child.linkLabel), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                      ]))
                    }), 128))
                  ]),
                  _: 2
                }, 1024))
              : (_openBlock(), _createBlock(_component_a_menu_item, {
                  key: item.linkTo,
                  onClick: ($event: any) => (go(item.linkTo))
                }, {
                  default: _withCtx(() => [
                    (item.icon)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: _normalizeClass(item.icon)
                        }, null, 2))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(item.linkLabel), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["selectedKeys"])
  ]))
}
}

})